import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22 11a1 1 0 0 0-1 1 9 9 0 1 1-9-9 8.9 8.9 0 0 1 4.42 1.166l-1.127 1.127A1 1 0 0 0 16 7h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1.707-.707L17.882 2.7A10.9 10.9 0 0 0 12 1a11 11 0 1 0 11 11 1 1 0 0 0-1-1z" }, null, -1)
  ])))
}
export default { render: render }